import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=4465b455&scoped=true&"
import script from "./DownLoad.vue?vue&type=script&lang=js&"
export * from "./DownLoad.vue?vue&type=script&lang=js&"
import style0 from "./DownLoad.vue?vue&type=style&index=0&id=4465b455&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465b455",
  null
  
)

export default component.exports